import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=6fe9b145&"
import script from "./Time.vue?vue&type=script&lang=js&"
export * from "./Time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/tafelgasten/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe9b145')) {
      api.createRecord('6fe9b145', component.options)
    } else {
      api.reload('6fe9b145', component.options)
    }
    module.hot.accept("./Time.vue?vue&type=template&id=6fe9b145&", function () {
      api.rerender('6fe9b145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Boek/Time.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Boek/Time.vue
// module id = 344
// module chunks = 0